<script>
	import { Router, Route } from "svelte-routing";
	import MainCarManagement from "./Manage/MainCarManagement.svelte";
	import CreateCarForm from "./CreateCarForm.svelte";
	import CarDetail from "./CarDetail/CarDetail.svelte";
	import EditCarForm from "./EditCarForm.svelte";
</script>

<Router url="/">
	<Route path="/" component={MainCarManagement} />
	<Route path="/create" component={CreateCarForm} />
	<Route path="/details/:vehicle_id" let:params>
		<CarDetail vehicleId={params.vehicle_id} />
	</Route>
	<Route path="/edit/:id" let:params>
		<EditCarForm vehicleId={params.id} />
	</Route>
</Router>
